import { render, staticRenderFns } from "./MeasureTaskDetail.vue?vue&type=template&id=0d2ff184"
import script from "./MeasureTaskDetail.vue?vue&type=script&lang=js"
export * from "./MeasureTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports